import Model from "~~/package/mapper/Model";
import { createModel } from "~~/package/utils/ModelUtil";
import { AdvancedAssessmentType } from "~~/package/mapper/proSkillAssure/model/AdvancedAssessmentType";

export class ProSkillAssureAiRecommendResultModel extends Model {
    constructor(
        public trackLevelId: number = 0,
        public trackName: string = "",
        public trackLevelTitle: string | null = null,
        public contentType: AdvancedAssessmentType | null = null,
        public recommendedLevel: string = "",
        public matchedKeywords: string[] = [],
        public testTemplateId: number | null = null,
        public taskCount: number | null = null,
        public recommendTime: number | null = null,
        public referenceUrl: string | null = null
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAiRecommendResultModel>): ProSkillAssureAiRecommendResultModel {
        return createModel<ProSkillAssureAiRecommendResultModel>(ProSkillAssureAiRecommendResultModel, {
            ...model,
            matchedKeywords: model.matchedKeywords ?? []
        });
    }
}
